import React from 'react'
import Frm_contacto from '../../../components/formularios/Frm_contacto/Frm_contacto';
import { Container } from 'semantic-ui-react';
import {useSelector} from 'react-redux'
import useTitle from '../../../components/Seo/useTitle';
import useSeo from '../../../components/Seo/useSeo';

const Contacto = (props) => {
    useTitle({title:'Contacto BICCI EXPRESS'})
    useSeo({description:'Contactanos!'})

    const activo = useSelector(store => store.usuario.activo)

   //  console.log(activo)

     React.useEffect(() => {
        // console.log(activo)
         if(activo){
             props.history.push('/soporte')
         }else{ props.history.push('/contacto')}
     }, [activo])

    return (
        <div>
        <Container className='bodycontent'>
        <br></br>
        <div>
        <Frm_contacto/>
        </div>
        <br></br>
        </Container> 
        </div>
       ); 
      };
    


export default Contacto